<template>
  <div class="masonry-gallery" v-if="images.length > 0">
    <div class="masonry-grid">
      <div
        v-for="(image, index) in images"
        :key="image.id"
        class="masonry-item"
        :class="getItemClass(index)"
        @click="openLightbox(index)"
      >
        <img
          :src="image.url"
          :alt="image.alt_text || 'Selected Cars luxury dealership'"
          loading="lazy"
        />
        <div class="masonry-item-overlay">
          <Icon icon="mdi:magnify-plus-outline" class="iconify" />
        </div>
      </div>
    </div>

    <!-- Lightbox -->
    <vue-easy-lightbox
      :visible="lightboxVisible"
      :imgs="lightboxImages"
      :index="lightboxIndex"
      :moveDisabled="false"
      :enableZoom="true"
      :loop="true"
      :teleport="'body'"
      @hide="lightboxVisible = false"
    />
  </div>
</template>

<script>
import axios from 'axios';
import VueEasyLightbox from 'vue-easy-lightbox';

export default {
  components: {
    VueEasyLightbox,
  },
  data() {
    return {
      images: [],
      lightboxVisible: false,
      lightboxIndex: 0,
    };
  },
  computed: {
    lightboxImages() {
      return this.images.map(img => img.url);
    },
  },
  mounted() {
    this.fetchGallery();
  },
  methods: {
    async fetchGallery() {
      try {
        const response = await axios.get('/api/gallery');
        this.images = response.data;
      } catch (error) {
        console.error('Error loading gallery:', error);
      }
    },
    getItemClass(index) {
      // Pseudo-random pattern that repeats every 12 items
      // Mix of tall, wide, and large items for visual variety
      const pattern = [
        'tall',   // 0 - tall (1x2)
        '',       // 1 - normal
        'wide',   // 2 - wide (2x1)
        '',       // 3 - normal
        '',       // 4 - normal
        'tall',   // 5 - tall
        'wide',   // 6 - wide
        '',       // 7 - normal
        'large',  // 8 - large (2x2)
        '',       // 9 - normal
        'tall',   // 10 - tall
        '',       // 11 - normal
      ];
      return pattern[index % pattern.length];
    },
    openLightbox(index) {
      this.lightboxIndex = index;
      this.lightboxVisible = true;
    },
  },
};
</script>

<style scoped>
.masonry-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  grid-auto-rows: 220px;
  grid-auto-flow: dense;
  gap: 12px;
}

.masonry-item {
  position: relative;
  overflow: hidden;
  cursor: pointer;
  border-radius: 6px;
}

.masonry-item img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
  transition: transform 0.6s ease;
}

.masonry-item:hover img {
  transform: scale(1.05);
}

/* Tall: spans 2 rows */
.masonry-item.tall {
  grid-row: span 2;
}

/* Wide: spans 2 columns */
.masonry-item.wide {
  grid-column: span 2;
}

/* Large: spans 2 columns + 2 rows */
.masonry-item.large {
  grid-column: span 2;
  grid-row: span 2;
}

.masonry-item-overlay {
  position: absolute;
  inset: 0;
  background: rgba(0, 0, 0, 0.35);
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: 0;
  transition: opacity 0.3s ease;
}

.masonry-item:hover .masonry-item-overlay {
  opacity: 1;
}

.masonry-item-overlay .iconify {
  color: #fff;
  font-size: 40px;
}

@media (max-width: 767px) {
  .masonry-grid {
    grid-template-columns: repeat(2, 1fr);
    grid-auto-rows: 160px;
    gap: 8px;
  }

  /* On mobile, large becomes just tall to avoid overflow */
  .masonry-item.large {
    grid-column: span 1;
    grid-row: span 2;
  }

  .masonry-item.wide {
    grid-column: span 1;
  }
}
</style>
